import { Component, Input } from '@angular/core';
import { AfOrderByPipe } from '@shared/filters/af-order-by/af-order-by.pipe';
import { NgStyle } from '@angular/common';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { PdfHeaderComponent } from '../pdf-header/pdf-header.component';

@Component({
    selector: 'pdf-table',
    templateUrl: './pdf-table.component.html',
    standalone: true,
    imports: [PdfHeaderComponent, AfTranslateDirective, NgStyle, AfOrderByPipe]
})
export class PdfTableComponent {
  pdfTable: any = {};
  @Input() configuration: any = {};
}
